module.exports = __webpack_public_path__ + "media/images/remittees_1-9a9be755483e9f8e8f213f05b093b309.jpg";